<template>
  <div class="main jcc ais">
    <div class="main__block">
      <div class="title">選擇部位</div>
      <div v-if="showReferralCodeCard && referralCodeData && referralCodeData.checked" class="referral-card" style="margin-bottom: 20px;">
        <div class="referral-code-block">
          <div class="referral-label">推薦碼</div>
          <div class="referral-code">{{ referralCodeData.referral_code }}</div>
        </div>
        <div class="referral-divider"></div>
        <div class="referral-period-block">
          <div class="referral-label">活動期間</div>
          <div class="referral-period">{{ referralCodeData.res_data.campaign_info.start }} 至 {{ referralCodeData.res_data.campaign_info.end }}</div>
        </div>
      </div>
      <div class="flex f-col jcs ais w-100">
        <div class="part__body">
          <div v-for="part in partList" :key="part" class="choose__item square">
            <input v-model="tempMedPart" :value="part" type="radio" />
            <div class="checkTag">
              <span>{{ part }}</span>
            </div>
          </div>
        </div>
        
        <div class="flex f-row jce w-100">
          <div @click="chooseMedProblem" class="btn next">下一步</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import airleeClinicList from '../config/airleeClinicList';
export default {
  name: 'ChooseMedPart',
  components: {},
  data() {
    return {
      tempMedPart: '',
    };
  },
  methods: {
    checkClinic() {
      const clinicCode = this.$route.query.clinicCode;
      if (clinicCode) {
        localStorage.setItem('clinicCode', clinicCode);
      } else {
        alert('診所代碼錯誤,請重新登入！');
        this.backToLogin();
      }
    },
    backToLogin() {
      const clinicCode = this.$route.query.clinicCode;
      this.$router.push(`/login?clinicCode=${clinicCode}`);
    },
    async chooseMedProblem() {
      const clinicCode = localStorage.getItem('clinicCode');
      if (!this.tempMedPart) {
        alert('尚未選擇部位！');
      } else {
        try {
          await this.$store.dispatch('resvModule/setMedPart', { data: this.tempMedPart, clinicCode, });
          this.$router.push(`/choose-med-problem?clinicCode=${this.$route.query.clinicCode}`);
        } catch (e) {
          const tokenError = ['無效的token', 'token錯誤', '該token已失效'];
          if (tokenError.indexOf(e) > -1) {
            alert('請重新登入');
            this.$router.push(`/login?clinicCode=${clinicCode}`);
          } else if (e == 'his api not found') {
            alert('請重新登入');
            this.$router.push(`/login?clinicCode=${clinicCode}`);
          } else {
            alert(e);
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters('authModule', ['customerByC', 'clinicByC', 'mgmIsEnableByC']),
    ...mapGetters('resvModule', ['roomByC', 'medByC']),
    ...mapGetters('mgmModule', ['referralCodeDataByC']),
    customer() {
      const clinicCode = this.$route.query.clinicCode;
      return this.customerByC(clinicCode);
    },
    room() {
      const clinicCode = this.$route.query.clinicCode;
      return this.roomByC(clinicCode);
    },
    clinic() {
      const clinicCode = this.$route.query.clinicCode;
      return this.clinicByC(clinicCode);
    },
    referralCodeData() {
      const clinicCode = this.$route.query.clinicCode;
      return this.referralCodeDataByC(clinicCode);
    },
    isAirleeClinic() {
      // 檢查當前診所是否為愛爾麗
      if (airleeClinicList.some(clinic => clinic.clinic_sn === this.$route.query.clinicCode)) {
        return true;
      }
      return false;
    },
    mgm_is_enable() {
      const clinicCode = this.$route.query.clinicCode;
      return this.mgmIsEnableByC(clinicCode);
    },
    showReferralCodeCard() {
      // 1) 先判斷是否愛爾麗，愛爾麗不受 mgm_is_enable 控制
      if (this.isAirleeClinic) {
        return true;
      }
      // 2) 一般診所：需 MGM 開關開啟
      return parseInt(this.mgm_is_enable, 10) === 1;
    },
    med() {
      const clinicCode = this.$route.query.clinicCode;
      return this.medByC(clinicCode);
    },
    partList() {
      let partList = ['臉','身體'];
      if (this.clinic.name.indexOf('木木日安') > -1 && this.med.name == '雷射除毛') {
        partList = ['腋下','小腿','大腿','手臂'];
      } else if (this.clinic.name == '本機測試' && this.med.name == '雷射除毛') {
        partList = ['腋下','小腿','大腿','手臂'];
      } else {
        partList = ['臉','身體'];
      }
      return partList;
    }
  },
  async created() {
    await this.checkClinic();
    window.scrollTo(0, 0);
  },
};
</script>
